// Hideo - Creators state: the page's open list (stored type, '' = closed) and search text, kept between page visits (a
// new creator, from the page "Add" or the create button, takes the open list's type), and the creator dialogs:
// the detail (CreatorDialog.vue), the edit dialog (CreatorEditDialog.vue) and the analysed video (AnalysedVideoDialog.vue),
// drawn by DialogHost.vue from the dialogs store.
import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { CreatorType } from '../data/types'
import { useDataStore } from './data'
import { useDialogsStore } from './dialogs'

export const useCreatorsStore = defineStore('creators', () => {
  const tab = ref<CreatorType | ''>('')
  const query = ref('')
  /** The creator of the last detail opened: the analysed video dialog belongs to it */
  const selected = ref('')

  const dialogs = useDialogsStore()
  const exists = (id: string) => useDataStore().getData().creators.some(c => c.id === id)

  /** Detail of a creator (nothing for an unknown one). Opening it again while it is open shows the new creator in place */
  function openDetail(id: string) {
    selected.value = id
    if (exists(id)) dialogs.show('creator', { id })
  }
  const closeDetail = () => dialogs.hide('creator')

  /** Edit dialog: an existing creator, or a new one (type: its stored type, by default the open list's, otherwise
   *  Competitor). fromDetail: closing it opens the detail again */
  function openEdit(id: string | null = null, type = '', fromDetail = false) {
    dialogs.show('creatorEdit', { id: id || null, type: type || tab.value || 'Competitor', fromDetail })
  }
  /** "Edit Profile" in the detail: the detail closes and comes back when the edit dialog closes */
  function editFromDetail() {
    closeDetail()
    openEdit(selected.value, '', true)
  }
  /** Closes the edit dialog; back = return to the detail when it was opened from there (not after a delete) */
  function closeEdit(back = true) {
    const a = dialogs.args.creatorEdit
    dialogs.hide('creatorEdit')
    if (back && a?.fromDetail && exists(selected.value)) dialogs.show('creator', { id: selected.value })
  }

  /** Analysed video of the selected creator: an existing one, or a new one (id null), possibly made from a video to
   *  analyse (todoId) */
  const openAnalysed = (id: string | null = null, todoId: string | null = null) =>
    dialogs.show('analysedVideo', { creatorId: selected.value, id: id || null, todoId: todoId || null })

  return { tab, query, selected, openDetail, closeDetail, openEdit, editFromDetail, closeEdit, openAnalysed }
})
